module.exports = __webpack_public_path__ + "img/logo-lcy.847abd8e.png";